module.exports = __webpack_public_path__ + "static/img/8.fd1dc8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/version/03/8.png
// module id = 8FT2
// module chunks = 1